import { inject, Injectable } from '@angular/core';
import { FormBuilder } from '@angular/forms';

/**
 * Default page size used by credit cards table.
 */
export const CREDIT_CARDS_TABLE_PAGE_SIZE = 10;

/**
 * Filters form service for credit cards table.
 */
@Injectable()
export class CreditCardsFiltersFormService {
  /**
   * Initial form values.
   */
  public readonly initialValues = {
    page: 1,
    offset: CREDIT_CARDS_TABLE_PAGE_SIZE,
    search: '',
  };

  /**
   * Form builder instance.
   */
  private readonly fb = inject(FormBuilder);

  /**
   * Filters form model.
   */
  public readonly filters = this.fb.group({
    page: this.initialValues.page,
    offset: this.initialValues.offset,
    search: this.initialValues.search,
  });
}
